'use client';

import { useInfiniteQuery, useMutation } from '@tanstack/react-query';
import { renderPickerService } from '../api/render-picker.service';

/**
 * Query key for render picker
 */
export const renderPickerQueryKey = (favoritesOnly: boolean) => [
  'render-picker',
  { favoritesOnly },
];

/**
 * Hook for fetching renders with infinite scroll pagination
 */
export function useRenderPicker(favoritesOnly: boolean = false) {
  return useInfiniteQuery({
    queryKey: renderPickerQueryKey(favoritesOnly),
    queryFn: ({ pageParam = 1 }) =>
      renderPickerService.getRenders({
        page: pageParam,
        favoritesOnly,
      }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.hasMore) {
        return allPages.length + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

/**
 * Hook for downloading a render as a File. No lockId — download is a
 * pure read; nothing on the server changes, no WS events to race.
 */
export function useDownloadRender() {
  return useMutation({
    mutationKey: ['renders', 'download'],
    mutationFn: ({
      imageUrl,
      filename,
    }: {
      imageUrl: string;
      filename?: string;
    }) => renderPickerService.downloadRender(imageUrl, filename),
  });
}
